import { render, staticRenderFns } from "./blogrollstype.vue?vue&type=template&id=bf0e7b52&scoped=true&"
import script from "./blogrollstype.vue?vue&type=script&lang=js&"
export * from "./blogrollstype.vue?vue&type=script&lang=js&"
import style0 from "./blogrollstype.vue?vue&type=style&index=0&id=bf0e7b52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0e7b52",
  null
  
)

export default component.exports